<form *ngIf="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm)">
  <div fxLayout="row" fxLayoutAlign="center center" class="card">
    <mat-card>
      <mat-card-header>
        <mat-card-title class="mat-h2">Login to CardBro</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field class="full-width">
          <input matInput type="email" placeholder="Email" formControlName="username" required autofocus
                 [cdkTrapFocusAutoCapture]="!loading" [cdkTrapFocus]="false">
        </mat-form-field>
        <mat-form-field class="full-width">
          <input matInput type="password" placeholder="Password" formControlName="password" required>
        </mat-form-field>
        <mat-checkbox formControlName="remind">Remember me</mat-checkbox>
      </mat-card-content>
      <mat-card-actions align="end">
        <a mat-button routerLink="/forgot-password" type="button">Forgot
          password</a>
        <button mat-raised-button type="submit" color="primary" [class.spinner]="loading"
                [disabled]="loading || !loginForm.valid">Login
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</form>
